import { type TJsonQuery } from '../../../packages/JsonQuery';
import { fetchOffers } from '../fetchOffers';
import {
  selectEtazhiBlackFridayPromoOffersData,
  selectIsEtazhiBlackFridayEnabled,
  selectIsEtazhiBlackFridayFilterEnabled,
} from 'shared/selectors/etazhiBlackFriday';
import { getIsFlatSale, getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

import type { IAppState } from 'shared/common/state';
import type { IApplicationContext } from 'shared/types/applicationContext';
import type { IOffersData } from 'shared/types/offersData';

interface IParameters {
  jsonQuery: TJsonQuery;
  getState: () => IAppState;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export async function fetchEtazhiBlackFridayDataIfNeeded(
  context: IApplicationContext,
  { jsonQuery, getState }: IParameters,
): Promise<IOffersData | null> {
  const state = getState();

  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  /**
   * Выключена РСка всего проекта
   */
  if (!isEnabled) {
    return null;
  }

  const etazhiPromoOffersData = selectEtazhiBlackFridayPromoOffersData(state);

  /**
   * Нет данных РСки для "промо-полки" (вся РС выкл. или null), или
   * флаг enabled внутри РСки равен false
   */
  if (!etazhiPromoOffersData?.enabled) {
    return null;
  }

  const isStartDatePassed = getIsStartDatePassed(etazhiPromoOffersData);

  /**
   * Включена РСка компонента "Промо-полки", но дата старта
   * промо-кампании ещё не наступила
   */
  if (!isStartDatePassed) {
    return null;
  }

  const isFlatSale = getIsFlatSale(jsonQuery);

  /**
   * Неподходящая категория недвиж. и тип сделки
   */
  if (!isFlatSale) {
    return null;
  }

  const isEtazhiBlackFridayFilterEnabled = selectIsEtazhiBlackFridayFilterEnabled(state);

  /**
   * Если фильтр чёрной пятницы включён, то не нужно запрашивать данные для "промо-полки"
   */
  if (isEtazhiBlackFridayFilterEnabled) {
    return null;
  }

  const etazhiBlackFridayJsonQuery = {
    ...jsonQuery,
    ...etazhiPromoOffersData?.jsonQuery,
  };

  const offers = await fetchOffers(context, {
    jsonQuery: etazhiBlackFridayJsonQuery,
  });

  return offers;
}
